import { render } from "./CreateCreatorAccountForm.vue?vue&type=template&id=1dafd38d"
import script from "./CreateCreatorAccountForm.vue?vue&type=script&lang=js"
export * from "./CreateCreatorAccountForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__